import { Box, Card, Dialog, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { IAppointmentView } from '../../../../services';
import { EventDetails } from './EventDetails';

interface IEventProps {
  firstTime: number;
  currentEvent: IAppointmentView;
  columnIndex: number;
  totalColumns: number;
  hourHeight: number;
  maxLengthDescription: number;
  refetch: () => any;
  refetchAppointments: () => any;
}

export const Event: React.FC<IEventProps> = ({
  firstTime,
  currentEvent,
  columnIndex,
  totalColumns,
  hourHeight,
  maxLengthDescription,
  refetch,
  refetchAppointments
}) => {
  const [openDialogEdit, setOpenDialogEdit] = useState(false);

  const calculateTop = () => {
    const [startHours, startMinutes] = currentEvent.startTime.split(':').map(Number);
    const totalStartMinutes = startHours * 60 + startMinutes;
    return ((totalStartMinutes / 60) - firstTime) * hourHeight;
  };

  const calculateHeight = () => {
    const [startHours, startMinutes] = currentEvent.startTime.split(':').map(Number);
    const [endHours, endMinutes] = currentEvent.endTime.split(':').map(Number);
    const totalStartMinutes = startHours * 60 + startMinutes;
    const totalEndMinutes = endHours * 60 + endMinutes;
    const totalMinutes = totalEndMinutes - totalStartMinutes;
    return (totalMinutes / 15) * (hourHeight / 4);
  };

  const top = calculateTop();
  const height = calculateHeight();
  const widthPct = 100 / totalColumns;
  const leftPct = widthPct * columnIndex;

  const title = `${currentEvent.customerName} | ${currentEvent.employeeName} | ${currentEvent.startTime} às ${currentEvent.endTime}`;
  const shortTitle = title.length > maxLengthDescription
    ? `${title.substring(0, maxLengthDescription)}...`
    : title;
  const services = currentEvent.services.map(s => s.description).join(', ');

  return (
    <>
      <Tooltip title={title}>
        <Card
          key={currentEvent.id}
          onClick={() => setOpenDialogEdit(true)}
          sx={{
            position: 'absolute',
            top: `${top}px`,
            left: `calc(${leftPct}% + 2px)`,
            width: `calc(${widthPct}% - 4px)`,
            height: `${height - 2}px`,
            zIndex: columnIndex + 1,
            borderRadius: '8px',
            border: '1px solid rgba(0,0,0,0.05)',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            transition: 'all 0.2s ease-in-out',
            cursor: 'pointer',
            '&:hover': {
              boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
              transform: 'scale(1.02)'
            },
          }}
        >
          <Box
            height='100%'
            px={1.5}
            py={0.75}
            display='flex'
            flexDirection='column'
            sx={{
              backgroundColor: currentEvent.canceled ? 'grey.500' : currentEvent.employeeColor,
              opacity: currentEvent.canceled ? 0.6 : 0.95,
              color: '#fff',
              textShadow: '0px 1px 3px rgba(0,0,0,0.4)',
            }}
          >
            <Box display='flex' alignItems='flex-start' sx={{ minWidth: 0 }}>
              <Typography
                variant='body2'
                sx={{
                  fontWeight: 600,
                  lineHeight: 1.3,
                  textDecoration: currentEvent.canceled ? 'line-through' : 'none',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  minWidth: 0,
                }}
              >
                {!currentEvent.canceled && currentEvent.status === 1 && (
                  <Box component='span' sx={{ color: '#f0ad4e', fontSize: 12, mr: 0.25 }}>●</Box>
                )}
                {!currentEvent.canceled && currentEvent.status === 2 && (
                  <Box component='span' sx={{ color: '#d9534f', fontSize: 12, mr: 0.25 }}>●</Box>
                )}
                {currentEvent.isWalkIn ? '🚶 ' : ''}{shortTitle}{services ? ` • ${services}` : ''}
              </Typography>
            </Box>
          </Box>
        </Card>
      </Tooltip>

      <Dialog open={openDialogEdit} onClose={() => setOpenDialogEdit(false)}>
        <EventDetails
          appointment={currentEvent}
          refetch={refetch}
          refetchAppointments={refetchAppointments}
          onClose={() => setOpenDialogEdit(false)}
        />
      </Dialog>
    </>
  );
};